// 引入i18n国际化插件
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh-CN',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('../lang/zh-CN.js'),   // 中文语言包
    'en': require('../lang/en.js'),    // 英文语言包
    'zh-TW': require('../lang/zh-TW.js')    // 繁体语言包
  }
})
export default i18n



// WEBPACK FOOTER //
// ./src/common/config/i18n.js